import { atom } from "recoil";

export const UseridState = atom({
  key: "UseridState",
  default: "",
});

export const emailState = atom({
  key: "emailState",
  default: "",
});
